<template>
  <a v-if="url" class="card-ctn" :href="url" target="_blank">
    <div class="card">
      <div class="card__front">
        <img :src="logoImage" :alt="`${$t('alt.logo')} ${logoName}`">
      </div>
      <div class="card__back">
        <img :src="screenshotImage" alt="null" aria-hidden="true">
      </div>
    </div>
  </a>
  <span v-else class="card-ctn">
    <div class="card">
      <div class="card__front">
        <img :src="logoImage" :alt="`${$t('alt.logo')} ${logoName}`">
      </div>
      <div class="card__back">
        <img :src="screenshotImage" alt="null" aria-hidden="true">
      </div>
    </div>
  </span>
</template>
<script>

import globo from '@/assets/images/logos/globo.svg'
import futura from '@/assets/images/logos/canal-futura.svg'
import estadao from '@/assets/images/logos/estadao.svg'
import istoe from '@/assets/images/logos/istoe.svg'
import bloomberg from '@/assets/images/logos/bloomberg.svg'
import rn from '@/assets/images/logos/rn-record-news.jpg'
import lide from '@/assets/images/logos/lide.svg'
import voceSa from '@/assets/images/logos/voce-sa.svg'
import abcColor from '@/assets/images/logos/abc-color.svg'
import exame from '@/assets/images/logos/exame.svg'
import laNacion from '@/assets/images/logos/la-nacion.svg'
import oPovo from '@/assets/images/logos/o-povo.svg'
import istoeDinheiro from '@/assets/images/logos/istoe-dinheiro.svg'

import g1Screenshot from '@/assets/images/screenshots/g1-site.jpg'
import futuraScreenshot from '@/assets/images/screenshots/canal-futura-site.jpg'
import estadaoScreenshot from '@/assets/images/screenshots/estadao-jornal.jpg'
import istoeScreenshot from '@/assets/images/screenshots/istoe-site.jpg'
import bloombergScreenshot from '@/assets/images/screenshots/bloomberg-site.jpg'
import rnScreenshot from '@/assets/images/screenshots/record-news-site.jpg'
import lideScreenshot from '@/assets/images/screenshots/meeting-revista.jpg'
import voceSaScreenshot from '@/assets/images/screenshots/voce-sa.jpg'
import abcColorScreenshot from '@/assets/images/screenshots/abc-color-site.jpg'
import exameScreenshot from '@/assets/images/screenshots/exame-site.jpg'
import laNacionScreenshot from '@/assets/images/screenshots/la-nacion-site.jpg'
import oPovoScreenshot from '@/assets/images/screenshots/o-povo-site.jpg'
import istoeDinheiroScreenshot from '@/assets/images/screenshots/istoe-dinheiro-site.jpg'

export default {
  name: 'Card',
  data () {
    return {
      logoImage: undefined,
      screenshotImage: undefined
    }
  },
  props: {
    logo: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    alt: String
  },
  computed: {
    logoName () {
      return this.logo.replace('-', ' ')
    }
  },
  methods: {
  },
  async mounted () {
    let logoImg
    let screenshotImg
    switch (this.logo) {
    case 'globo':
      logoImg = globo
      screenshotImg = g1Screenshot
      break
    case 'futura':
      logoImg = futura
      screenshotImg = futuraScreenshot
      break
    case 'estadao':
      logoImg = estadao
      screenshotImg = estadaoScreenshot
      break
    case 'istoe':
      logoImg = istoe
      screenshotImg = istoeScreenshot
      break
    case 'bloomberg':
      logoImg = bloomberg
      screenshotImg = bloombergScreenshot
      break
    case 'rn':
      logoImg = rn
      screenshotImg = rnScreenshot
      break
    case 'lide':
      logoImg = lide
      screenshotImg = lideScreenshot
      break
    case 'voce-sa':
      logoImg = voceSa
      screenshotImg = voceSaScreenshot
      break
    case 'abc-color':
      logoImg = abcColor
      screenshotImg = abcColorScreenshot
      break
    case 'exame':
      logoImg = exame
      screenshotImg = exameScreenshot
      break
    case 'la-nacion':
      logoImg = laNacion
      screenshotImg = laNacionScreenshot
      break
    case 'o-povo':
      logoImg = oPovo
      screenshotImg = oPovoScreenshot
      break
    case 'istoe-dinheiro':
      logoImg = istoeDinheiro
      screenshotImg = istoeDinheiroScreenshot
    }
    this.logoImage = logoImg
    this.screenshotImage = screenshotImg
  }
}
</script>
<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities
.card-ctn
  @apply mx-auto inline-block w-28 h-28
  perspective: 1000px
  @screen md
    @apply w-48 h-48
  &:hover
    .card
      transform: rotateY(180deg)
      &__front
        img
          @apply opacity-0

.card
  @apply relative w-full h-full cursor-pointer
  transition: transform 0.6s
  transform-style: preserve-3d
  &__front, &__back
    @apply absolute w-full h-full
    border-radius: 10px
    transition: background .3s
    backface-visibility: hidden
  &__front
    @apply z-20 inline-flex items-center justify-center shadow-md overflow-hidden p-2
    img
      transition: opacity .01s .15s
  &__back
    @apply z-10 shadow-md overflow-hidden
    transform: rotateY(180deg)
/* purgecss end ignore */
</style>
